<template>
  <div class="product-list">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="头衔名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入头衔名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品-->
    <div class="common-level-rail" style="display:flex;">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加头衔</el-button>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%">
          <!-- v-loading="loading" -->
          <el-table-column prop="name" align="center" label="头衔名称" width="150px">
          </el-table-column>
          <el-table-column prop="fileAddress" align="center" label="头衔图片">
            <template slot-scope="scope">
              <img :src="scope.row.fileAddress" width="30" height="30" />
            </template>
          </el-table-column>
          <el-table-column prop="sort" align="center" label="排序"></el-table-column>
          <!-- <el-table-column prop="status" label="是否显示" align="center" width="180">
            <template slot-scope="scope">
              <el-switch class="switch" @change='isShow(scope.row)' v-model="scope.row.status" :active-value="true" :inactive-value="false" active-text="是" inactive-text="否">
              </el-switch>
            </template>
          </el-table-column> -->

          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="primary" size="small">编辑头衔</el-button>
              <el-button @click="delClick(scope.row)" type="danger" size="small" v-if="scope.row.labelId!=9">删除头衔</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import HeadframeApi from "@/api/headframe.js";
export default {
  components: {
    // Add
  },
  data() {
    return {
      tableData: [],
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      searchForm: {
        name: ""
      },
      is_show: "" //头衔是否显示
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    /*打开添加*/
    addClick() {
      this.$router.push("/technician/headframe/add");
    },
    // 是否显示头衔
    isShow(row) {
      let self = this;
      HeadframeApi.labelshow({
        labelId: row.labelId,
        status: row.status
      }).then(data => {
        self.$message({
          message: "修改成功",
          type: "success"
        });
        self.getData();
      });
    },
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      HeadframeApi.labelList(Params, true)
        .then(data => {
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          // self.loading = false;
        });
    },
    /*打开编辑*/
    editClick(row) {
      console.log(row, "编辑技师");
      this.$router.push({
        path: "/technician/headframe/edit",
        query: {
          labelId: row.labelId,
          scene: "edit"
        }
      });
    },
    /*删除*/
    delClick: function(row) {
      let self = this;
      self
        .$confirm("确定删除该记录吗?", "提示", {
          type: "warning"
        })
        .then(() => {
          HeadframeApi.labeldelete({
            labelId: row.labelId
          }).then(data => {
            self.$message({
              message: "删除成功",
              type: "success"
            });
            self.getData();
          });
        });
    }
  }
};
</script>

<style scoped  lang='scss'>
.s_flex {
  display: flex;
  justify-content: space-between;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/headframe/index.vue